import { render, staticRenderFns } from "./OctadeskChat.vue?vue&type=template&id=a17e89f4&"
import script from "./OctadeskChat.vue?vue&type=script&lang=js&"
export * from "./OctadeskChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports